
import { computed, defineComponent } from 'vue';
import Modal from '@/components/info/Modal.vue';
import Button from '@/components/Button.vue';
import { useStepperNavigation } from '@/components/wizard';
import { createStore, useCalculations } from '@/lib/calculationstate';

export default defineComponent({
  name: 'TestimonialModal',
  props: {
    modelValue: null,
  },
  components: {
    Button,
    Modal,
  },
  setup(props, { emit }) {
    const { lastStep } = useStepperNavigation();
    const { state } = useCalculations();

    const testimonial = computed({
      get: () => props.modelValue,
      set: (v) => emit('update:modelValue', v),
    });

    const title = computed(() => `De situatie van ${testimonial.value.name}`);

    const applyState = () => {
      // Reset and apply 'testimonial' state
      Object.assign(state, createStore(), testimonial.value.state);
      testimonial.value = null;

      lastStep();
    };

    return {
      testimonial,
      title,
      applyState,
    };
  },
});
